/* eslint-disable no-use-before-define,no-eval */
import { ajax, cleanObject, toQueryString, } from '../twd/twd'
import { MODES } from './use-order-ticket'

export const confirm = async ({
    acctNo, action, cusip, qty, price, yld, priceOrYield, attested,
    orderInfo, setOrderInfo, hiddenState,
    sourceAction_, actionSubset_, sourceOrderNo_,
    mode, isTreasuryAuction, bestPrice, bestYield,
}) => {

    const f = (orderInfo.submit || '').indexOf('Place')===0
    if (!f) return

    const {
        dealerCode:p_dealer_code, tradeType:p_trade_type, settlement:p_settlement,
        submit:p_submit, ovalcdata:p_ovalcdata,
        statusMsg
    } = orderInfo
    const {
        p_price_init, p_yield_init, p_discount_init, p_settlement_init, p_id, p_order_type,
        p_wrap_acct, p_exec_type, p_seeded, p_validated, p_warning,
        p_mm, p_dd, p_yy, p_old_dlr_price, p_timestamp, p_validate_resp, p_valreq_id,
        p_order_trans_id, p_ocfg_order_no,
    } = hiddenState

    const isContinue = (statusMsg || '').toLowerCase().indexOf('click preview to continue') > 0
    const isLift = mode === MODES.ORDER_Z
    const isCounterDisallowed = orderInfo && orderInfo.countersAllowed==='N'

    let params = cleanObject({
        p_acct_no: acctNo,
        p_action: isTreasuryAuction ? 'B' : action,
        p_cusip: cusip,
        p_qty_bond: qty,
        p_price: isTreasuryAuction ? null
            : isCounterDisallowed ? bestPrice
            : price,
        p_yield: isTreasuryAuction ? null
            : isCounterDisallowed ? bestYield
            : yld,
        p_price_type: isTreasuryAuction ? 'A' : priceOrYield,
        p_misc4: attested ? 'Y' : '',

        p_submit,
        p_ovalcdata,
        p_valreq_id,
        p_validate_resp,

        // from hidden-states
        p_dd,
        p_dealer_code,
        p_discount_init,
        p_exec_type,
        p_id,
        p_mm,
        p_ocfg_order_no: isLift ? '' : p_ocfg_order_no,
        p_old_dlr_price,
        p_order_trans_id,
        p_order_type: isTreasuryAuction ? 'A' : p_order_type,
        p_price_init: isLift ? price : p_price_init,
        p_seeded: isTreasuryAuction ? 1 : p_seeded,
        p_settlement,
        p_settlement_init,
        p_timestamp,
        p_trade_type,
        p_validated: isContinue ? 'Y' : p_validated,
        p_warning: isContinue ? 'Y' : p_warning,
        p_wrap_acct,
        p_yield_init,
        p_yy,

        // from origin actionSubset_, sourceOrderNo_
        p_action_subset: actionSubset_,
        p_source_order_no: sourceOrderNo_,
        p_source_action: sourceAction_,

        // p_alloc_id: '',
        // p_broker_text: '',
        // p_called_from: '',
        // p_dtc: '',
        // p_execbroker: '',
        // p_javascript: '',
        // p_limittext: '',
        // p_markup_quantity: '',
        // p_max_bid_sc: '',
        // p_miscdata: '',
        // p_order_xref: '',
        // p_ovalcdata: '',
        // p_price_change_ind: '',
        // p_settlement_ent_val: '',
        // p_ticket_source: '',
        p_output_format: 'JSON',
        p_transdata: 'ETRADENOE(Y)',
    })

    try {
        const { data:order_ } = await ajax({
            url: '/esb/portfolio/trades/orderInput',
            method: 'POST',
            headers_: {
                'Content-Type': 'text/plain'
            },
            body: toQueryString(params).replace('%20', '+'),
            type: 'text',
        })

        const info = eval(await order_)
        info.orderStatusDesc = ORDER_STATUS[info.ordstatus]
        if (!info.orderStatusDesc) {
            throw new Error("unknown order status")
        }

        setOrderInfo(info)
        return info
    } catch(e) {
        Object.assign(orderInfo, {
            status: 'Fail',
            statusMsg: 'ERROR: There was an error processing your request.'
        })
        console.error('use-order-ticket-confirm', e)
    }

}

const ORDER_STATUS = {
    "0": "Open",
    "1": "Partially Filled (Pending Fill)",
    "2": "Filled",
    "3": "Done for day",
    "4": "Cancelled",
    "5": "Replaced",
    "6": "Pending Cancel",
    "8": "Rejected",
    "9": "Trade Cancelled",
    "A": "Pending New (Accepted)",
    "X": "Approved",
    "C": "Expired",
    "P": "Passed Update",
    "Y": "Pending Fill",
    "U": "Status Update",
    "S": "Showing",
}
